/**
 * Landing page configuration
 * Feature flags and settings for easy control
 */

export const config = {
  // Feature flags
  features: {
    pricingVisible: false, // Set to true when ready to show pricing page
    demoVideo: true, // Show video demo section
  },

  // Content settings
  content: {
    // YouTube video ID (from URL: youtube.com/watch?v=VIDEO_ID)
    // Set to null or empty string to hide video section
    youtubeVideoId: 'qoK4fBZnG0M',
  },

  // URLs
  urls: {
    mainApp: import.meta.env.VITE_MAIN_APP_URL || 'https://app.nazwolab.pl',
    apiLanding: import.meta.env.VITE_API_LANDING_ENDPOINT,
  },
} as const

export default config
